import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/frown-open': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM200 208C200 190.3 185.7 176 168 176S136 190.3 136 208 150.3 240 168 240 200 225.7 200 208zM328 176C310.3 176 296 190.3 296 208S310.3 240 328 240 360 225.7 360 208 345.7 176 328 176zM248 288C212.4 288 159.2 309.3 152.2 349.2 150.2 361 161.2 370.7 172.7 367.3 203.9 357.7 232.1 352 248 352S292.1 357.7 323.3 367.3C334.7 370.8 345.8 361 343.8 349.2 336.8 309.3 283.6 288 248 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/frown-open.js
// module id = GukA
// module chunks = 144